.main-container {
  display: flex;
}
